import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import FetchSelect from '../../../core/form/FetchSelect';
import Select from '../../../core/form/Select';
import Button from '../../../core/form/Button';
import { get, snakeCase } from 'lodash';

export default function PlacementTestReportStudentsListFilter(props) {
  return (
    <Row>
      <Column size={3}>
        <TextInput
          label="Student"
          placeholder="Search by email or name"
          value={get(props.values, 'keyword', null)}
          onChange={(value) => props.onChange('keyword', value)}
        />
      </Column>
      <Column size={3}>
        <FetchSelect
          url="/courses"
          multiple={true}
          disabled={props.isFetching}
          label="Level"
          placeholder="Select student level"
          value={get(props.values, 'placementTestLevel', '')}
          onChange={(value) => props.onChange('placementTestLevel', value)}
          resultFilter={(course) => !['Discovery', 'Adventures', 'C2'].find((c) => c === course.name)}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={3}>
        <Select
          disabled={props.isFetching}
          label="Status"
          placeholder="Filter by status"
          value={get(props.values, 'status', '')}
          onChange={(value) => props.onChange('status', value)}
          options={['Finished', 'Not finished'].map((status) => ({
            label: status,
            value: snakeCase(status),
          }))}
        />
      </Column>
      <Column size={2}>
        <div style={{ marginTop: '43px' }}>
          <Button label="Search" icon="search" onClick={props.onSearch} />
        </div>
      </Column>
    </Row>
  );
}

PlacementTestReportStudentsListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
};

PlacementTestReportStudentsListFilter.defaultProps = {
  isFetching: false,
};
